// Client-side preview of the inventory AMM. Server quotes remain authoritative.

export function unitBuyPrice(basePrice, targetInventory, stock) {
  const s = Math.max(1, Number(stock) || 0);
  return Math.ceil((Number(basePrice) * Number(targetInventory)) / s);
}

export function unitSellPrice(basePrice, targetInventory, stock) {
  const s = Math.max(0, Number(stock) || 0) + 1;
  return Math.floor((Number(basePrice) * Number(targetInventory)) / s);
}

export function previewBuyCost(listing, quantity) {
  const q = Math.max(0, Number.parseInt(quantity, 10) || 0);
  const stock = Number(listing?.current_inventory) || 0;
  const base = Number(listing?.base_price) || 0;
  const target = Number(listing?.target_inventory) || 0;
  if (q < 1 || stock - q < 1) return null;
  let gold = 0;
  for (let i = 0; i < q; i += 1) {
    gold += unitBuyPrice(base, target, stock - i);
  }
  return gold;
}

export function previewSellProceeds(listing, quantity) {
  const q = Math.max(0, Number.parseInt(quantity, 10) || 0);
  const stock = Number(listing?.current_inventory) || 0;
  const base = Number(listing?.base_price) || 0;
  const target = Number(listing?.target_inventory) || 0;
  if (q < 1) return null;
  let gold = 0;
  for (let i = 0; i < q; i += 1) {
    gold += unitSellPrice(base, target, stock + i);
  }
  return gold;
}
